// =======================
// src/paginas/analise/autorizarCadastro/AprovarCadastroPage.js
// =======================
import React from "react";
import { useParams } from "react-router-dom";
import EscolaInfo from "./componentesPaginaVi/visualizarEscola";
import MantenedoraInfo from "./componentesPaginaVi/visualizarMantenedora";
import { Box, Typography } from "@mui/material";

const blueTheme = {
  primary: "#1976d2",
  background: "#f5f9ff",
};

const AprovarCadastroPage = () => {
  const { tipo } = useParams();

  return (
    <Box
      sx={{
        backgroundColor: blueTheme.background,
        minHeight: 0,
        display: { xs: "block", md: "flex" },
        flexDirection: "column",
        flex: "1 1 auto",
      }}
    >
      {tipo === "escola" ? (
        <EscolaInfo />
      ) : tipo === "mantenedora" ? (
        <MantenedoraInfo />
      ) : (
        <Typography variant="h6" sx={{ p: 3, color: blueTheme.primary }}>
          Tipo inválido
        </Typography>
      )}
    </Box>
  );
};

export default AprovarCadastroPage;
